<template>
  <div>
    <z-container>
      <h3 class="text-body-1 mb-3">Contas a Receber</h3>

      <v-row justify="center">
        <v-col cols="12">
          <v-card class="mb-3">
            <v-card-title>
              <span class="text-subtitle-2">Filtro - Contas a Receber</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="pb-5">
              <v-row dense>
                <v-col sm="9">
                  <v-autocomplete
                    v-model="filtro.cliente_id"
                    filled
                    dense
                    clearable
                    placeholder=" "
                    label="Cliente"
                    :items="$store.getters['listas/clientes']"
                    hide-details
                  ></v-autocomplete>
                </v-col>
              <!-- </v-row>
              <v-row dense> -->
                <v-col cols="12" sm="3">
                  <v-select
                    filled
                    dense
                    placeholder=" "
                    clearable
                    :items="$globals.FORMAS_DE_PAGAMENTO"
                    v-model="filtro.forma_de_pagamento"
                    label="Forma de Pagamento"
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-select
                    filled
                    dense
                    placeholder=" "
                    :items="situacoes"
                    v-model="filtro.situacao"
                    label="Situação"
                    @change="onChangeSituacao"
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="3">
                  <z-date-picker-menu
                    filled
                    dense
                    clearable
                    v-model="filtro.data_inicial"
                    label="Vencimento Inicial"
                    placeholder=" "
                    hide-details
                    :disabled="dataDisabled"
                  ></z-date-picker-menu>
                </v-col>
                <v-col cols="12" sm="3">
                  <z-date-picker-menu
                    filled
                    dense
                    clearable
                    v-model="filtro.data_final"
                    label="Vencimento Final"
                    placeholder=" "
                    hide-details
                    :disabled="dataDisabled"
                  ></z-date-picker-menu>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    v-model="filtro.loja_id"
                    filled
                    dense
                    clearable
                    placeholder=" "
                    label="Lojas"
                    :items="$store.getters['listas/lojas']"
                    hide-details
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-switch 
                class="my-0" 
                color="primary" 
                label="Imprimir Detalhado" 
                v-model="detalhado"
                hide-details
                :disabled="detalhado_disabled">
              </v-switch>
              <v-switch 
                class="ml-4 my-0" 
                color="primary" 
                label="Imprimir Agrupado" 
                v-model="agrupado" 
                hide-details
                @click="agrupadoClick">
              </v-switch>
              <v-spacer></v-spacer>
              <v-btn text @click="imprimir" :disabled="promissorias.length == 0">
                <v-icon left>mdi-printer</v-icon>
                Imprimir
              </v-btn>
              <v-btn depressed color="primary" @click="filtrar" :loading="loading">Filtrar</v-btn>
            </v-card-actions>
          </v-card>

          <v-card>
            <v-card-title>
              <span class="text-subtitle-2">Contas a Receber ({{ this.promissorias.length }})</span>
            </v-card-title>
            <v-divider></v-divider>

            <v-data-table
              id="promissorias"
              item-key="id"
              disable-pagination
              hide-default-footer
              :items="promissorias"
              :headers="headers.promissorias"
              :loading="false"
              :search="search.promissorias"
            >
              <template v-slot:item="{ item: promissoria }">
                <tr class="apontador">
                  <td>{{ promissoria.documento }}</td>
                  <td>{{ promissoria.razao }}</td>
                  <td>{{ promissoria.forma_pagamento }}</td>
                  <td style="max-width: 100px" class="text-truncate" :title="promissoria.observacoes">{{ promissoria.observacoes}}</td>
                  <td>{{ promissoria.vencimento | dataBR }}</td>
                  <td class="text-right">{{ promissoria.valor | valorBR }}</td>
                  <td class="text-right">
                    {{ promissoria.valor_pago | valorBR }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ promissoria.valor_restante | valorBR }}
                  </td>
                  <td class="text-center">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon @click="abrirExtratoCliente(promissoria)">
                          <v-icon>mdi-playlist-check</v-icon>
                        </v-btn>
                      </template>
                      <span>Ir para o Extrato</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <template v-slot:body.append="{ items }">
                <tr>
                  <td colspan="6" class="text-right font-weight-bold">
                    {{ somaPromissorias | valorBR }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ somaPromissoriasPagas | valorBR }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ somaPromissoriasRestante | valorBR }}
                  </td>
                  <!-- <td></td> -->
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </z-container>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import config from "@/app/config";
import qs from "qs";

import { parseParams } from "@/app/helpers/utils";

export default {
  name: "contas-a-receber-lista",

  data() {
    return {
      filtro: {
        cliente_id: '',
        situacao: "Abertas",
        data_inicial: "",
        data_final: "",
        forma_de_pagamento: "",
      },
      detalhado: false,
      detalhado_disabled: false,
      agrupado: false,
      search: {
        pedidos: "",
        promissorias: "",
        cheques: "",
      },
      headers: {
        promissorias: [
          { text: "Documento", value: "documento", width: "120px" },
          { text: "Cliente", value: "razao" },
          { text: "Tipo", value: "forma_pagamento" },
          { text: "Obs", value: "observacoes" },
          { text: "Vencimento", value: "vencimento", width: "100px" },
          { text: "Valor", value: "valor", align: "right", width: "150px" },
          {
            text: "Valor Pago",
            value: "valor_pago",
            align: "right",
            width: "110px",
          },
          {
            text: "Restante",
            value: "valor_restante",
            align: "right",
            width: "130px",
          },
          { text: 'Opções', align: 'center', sortable: false }
        ],
      },
      btnGroups: {
        pedidos: "Todos",
        promissorias: "Todos",
        cheques: "Todos",
      },
      tab: null,
      loading: false,
      situacoes: [
        { text: "Todas", value: "Todas" },
        { text: "Em aberto", value: "Abertas" },
        { text: "Quitadas", value: "Pagas" },
        { text: "Vencidas", value: "Vencidas" },
        { text: "A Vencer", value: "AVencer" },
      ],
    };
  },

  inject: ["$imprimir"],

  computed: {
    ...mapState("financeiro", ["promissorias"]),
    ...mapGetters("financeiro", [
      "somaPromissorias",
      "somaPromissoriasPagas",
      "somaPromissoriasRestante",
    ]),

    dataDisabled() {
      return (
        this.filtro.situacao == "Vencidas" || this.filtro.situacao == "AVencer"
      );
    },
  },

  beforeRouteLeave(to, from, next) {
    // this.limparlistas();
    next();
  },

  mounted() {
    this.setTitulo("Contas a Receber");
    this.$store.dispatch("listas/clientes");
    this.$store.dispatch("listas/lojas");
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapMutations("financeiro", ["limparlistas", "LIMPAR_PROMISSORIAS"]),
    ...mapMutations("recebimentos", [
      "limparPromissorias",
      "adicionarPromissoria",
      "setCliente",
    ]),
    ...mapActions("financeiro", ["contasareceber"]),

    async filtrar() {
      try {
        this.loading = true;
        await this.contasareceber(this.filtro);
      } catch (error) {
        this.$eventbus.erroSistema(error);
      } finally {
        this.loading = false;
      }
    },

    receber(promissoria) {
      // this.limparPromissorias();
      this.adicionarPromissoria(promissoria);
      this.setCliente(this.filtro.cliente_id);
      this.$router.push("/financeiro/contasareceber/recebimento");
    },

    imprimir(pedido) {
      this.filtro.detalhado = this.detalhado || false;
      this.filtro.agrupado = this.agrupado || false;
      this.$imprimir("/financeiro/contasareceber/imprimir?" + new URLSearchParams(parseParams(this.filtro)).toString());
    },

    onChangeSituacao(situacao) {
      if (["Vencidas", "AVencer"].indexOf(situacao) > -1) {
        this.filtro.data_inicial = "";
        this.filtro.data_final = "";
      }
    },

    async abrirExtratoCliente(promissoria) {
      // this.$store.commit("financeiro/limparlistas");
      await this.$store.dispatch("clientes/abrir", promissoria.cliente_id);
      this.$store.commit("financeiro/SET_TAB", 1);
      this.$store.commit('clientes/SET_BUSCA', promissoria.razao);
      this.$router.push({ name: "ExtratoCliente" });
      await this.$store.dispatch("financeiro/extratocliente");
    },

    agrupadoClick() {
      this.detalhado = false;
      this.detalhado_disabled = this.agrupado ? true : false;
    }
  },
  watch: {
    filtro: {
      deep: true,
      handler(newValue, oldValue) {
        console.log(new Date);
        // if (newValue != oldValue) {
          this.filtrar();
        // }
      }
    }
  },
};
</script>

<style scoped>
.x-small {
  font-size: 11px;
  height: 18px;
}
</style>
